
// window.annimateabout = false
$(document).scroll(function () {
  if (!$('#fourtitle').length) {
    return
  }
  // console.log($('#bodyone'));
  var topScroll = jQuery(window).scrollTop();
  var inner = window.innerHeight;
  // if ($('#firsttitle').offset().top - topScroll <= inner) {
  //     $('#firsttitle').addClass('animated fadeInUp')
  // }
  // if ($('.firstimg').offset().top - topScroll <= inner) {
  //     $('.firstimg').addClass('animated fadeInUp')
  // }
  // if ($('.firstinfoinfo').offset().top - topScroll <= inner) {
  //     $('.firstinfoinfo').addClass('animated fadeInUp')
  // }
  if ($('#secondtitle').offset().top - topScroll <= inner) {
    $('#secondtitle').addClass('animated fadeInUp')
  }
  if ($('.mapimg').offset().top - topScroll <= inner) {
    $('.mapimg').addClass('animated fadeInUp')
  }
  if ($('.culturetitle').offset().top - topScroll <= inner) {
    $('.culturetitle').addClass('animated fadeInUp')
  }
  if ($('.culturesubtitle').offset().top - topScroll <= inner) {
    $('.culturesubtitle').addClass('animated fadeInUp')
  }
  if ($('.mapinfo').offset().top - topScroll <= inner) {
    $('.mapinfo').addClass('animated fadeInUp')
  }
  if ($('#thirdtitle').offset().top - topScroll <= inner) {
    $('#thirdtitle').addClass('animated fadeInUp')
  }
  if ($('#first').offset().top - topScroll <= inner) {
    $('#first').addClass('animated fadeInUp')
  }
  if ($('#fourtitle').offset().top - topScroll <= inner) {
    $('#fourtitle').addClass('animated fadeInUp')
  }
  if ($('#second').offset().top - topScroll <= inner) {
    $('#second').addClass('animated fadeInUp')
  }
  if ($('.threelist').offset().top - topScroll <= inner) {
    // console.log('<<<<<<<<<<<<');
    if (window.annimateabout) {
      return;
    }
    window.annimateabout = true;

    var valuees = localStorage.getItem('valuees');
    var base = JSON.parse(valuees);
    var valuee = base.valuee;
    var valuee2 = base.valuee2;
    var valuee3 = base.valuee3;
    var valuee4 = base.valuee4;
    // var { valuee, valuee2, valuee3, valuee4 } = base
    $('.threelist').addClass('animated fadeInUp');

    $('#numberone').addClass('value');
    $('#numbertwo').addClass('value2');
    $('#numberthree').addClass('value3');
    $('#numberfour').addClass('value4');
    $(".value").numberRock({
      speed: valuee.s,
      count: valuee.v
    })
    $(".value2").numberRock({
      speed: valuee2.s,
      count: valuee2.v
    })
    $(".value3").numberRock({
      speed: valuee3.s,
      count: valuee3.v
    })
    $(".value4").numberRock({
      speed: valuee4.s,
      count: valuee4.v
    })
  }

})


//////////////////
// WEBPACK FOOTER
// ./utils/about.js
// module id = Vepe
// module chunks = 1